import { withStyles } from '@material-ui/core';

import ParkingPage from './component';
import styles from './styles';

export default withStyles(styles)(ParkingPage);
